var tableScroll = (function () {

    function mobileTableScroll() {
        var scrollTable = document.querySelector(".mod-table--scroll");
        if (!scrollTable) {
            return;
        }
        var scrollTableParent = scrollTable.parentElement;
        scrollTableParent.closest(".mod-flex").firstElementChild.style.minWidth = "0";
    }

    return {
        mobileTableScroll: mobileTableScroll
    };

})();

window.addEventListener("load", tableScroll.mobileTableScroll);